import React, { FunctionComponent, useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { pruneObject } from '../../utils/objectManagement'

import { AlertsStore } from '../../typings/stores/AlertsStore'
import { AlertsTableContext } from '.'
import { PageHeading, SearchInput } from '../../components'
import AlertTable from './AlertsTable'

import { getAlerts } from '../../actions/alerts'
import { State } from '../../reducers'

import styles from './styles.module.css'
import { Website } from '../../typings/website'

const Alerts: FunctionComponent = () => {
  const dispatch = useDispatch()

  const alertsLoading = useSelector<State, boolean>(
    state => state.alerts.status === 'fetching'
  )

  const alerts = useSelector<State, AlertsStore>(state => state.alerts)
  const activeProperty = useSelector<State, Website>(
    state => state.user.activeWebsite
  )
  const {
    changePage,
    changePageSize,
    changeSort,
    filters,
    pagination: { page, size },
    setFilter,
    sort,
  } = useContext(AlertsTableContext)

  const fetchAlerts = () =>
    dispatch(getAlerts({ ...filters, ...pruneObject(sort), size, page }))

  // This handles the case when you pass a subject but you are on something other than page 1
  useEffect(() => {
    if (page !== 1) {
      changePage(1)
    }
  }, [filters.subject])

  useEffect(() => {
    fetchAlerts()
  }, [size, page, sort, filters.subject, activeProperty])

  return (
    <>
      <PageHeading title="Alerts" className={styles.heading}>
        <div className={styles.searchContainer}>
          <SearchInput
            onChange={debounce(value => setFilter('subject', value), 400)}
          />
        </div>
      </PageHeading>

      <AlertTable
        loading={alertsLoading}
        alerts={alerts}
        paginate={true}
        onSortChange={changeSort}
        sort={sort}
        onPageSizeUpdate={changePageSize}
        onPaginate={changePage}
      />
    </>
  )
}

export default Alerts
